import React from 'react';
import { string, bool, object } from 'prop-types';

import Classes from './Skeleton.scss';

const SkeletonBase = ({
  width = '',
  height = '',
  className = '',
  style = {},
  as = 'div',
  withAnimation = true,
  ...rest
}) => {
  const styles = {
    ...style,
    ...(width ? { width } : {}),
    ...(height ? { height } : {}),
  };

  const As = as || 'div';
  return (
    <As
      {...rest}
      className={`${Classes.BaseSkeleton} ${className} ${withAnimation ? Classes.withAnimation : ''}`}
      style={styles}
    />
  );
};

SkeletonBase.propTypes = {
  withAnimation: bool,
  type: string,
  className: string,
  width: string,
  height: string,
  style: object,
  as: string,
};

export default SkeletonBase;
